"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var BottomSheet_1 = __importDefault(require("stremio/components/BottomSheet"));
var Selection_1 = __importDefault(require("./Selection"));
var FiltersSheet_less_1 = __importDefault(require("./FiltersSheet.less"));
var FiltersSheet = function (_a) {
    var inputs = _a.inputs, show = _a.show, onCloseRequest = _a.onCloseRequest;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(BottomSheet_1.default, { className: FiltersSheet_less_1.default['sheet'], show: show, onCloseRequest: onCloseRequest, closeOnContentClick: false, closeOnOrientationChange: false, flush: true, ariaLabel: t('CATALOG_FILTERS') },
        react_1.default.createElement(Selection_1.default, { inputs: inputs, onCloseRequest: onCloseRequest })));
};
exports.default = FiltersSheet;
